import { HOME_HERO_GRADIENT_DESKTOP } from '@/src/components/common/home/common/homeHeroBackground'
import { Box } from '@mui/material'
import React, { ReactNode } from 'react'

interface FlightContainerProps {
    children: ReactNode
    /**
     * Suppresses the Flyin gradient — Heya paints a photo instead
     */
    isHeya?: boolean,
    hideGradient?: boolean
}


export const FlightContainer: React.FC<FlightContainerProps> = ({ children, hideGradient, isHeya = false }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
                px: { sm: 2, md: 3 },
                pb: { sm: 2, md: 1 },
                // Desktop: gradient stops at tabs bottom. Heya swaps it for the hero photo,
                // rendered as a layer below so it can be mirrored for RTL.
                background: {
                    xs: 'none', // Mobile: no gradient on container
                    lg: isHeya || hideGradient ? 'none' : HOME_HERO_GRADIENT_DESKTOP
                },
                backgroundPosition: {
                    xs: 'auto',
                    lg: 'top center'
                },
                backgroundRepeat: {
                    xs: 'repeat',
                    lg: 'no-repeat'
                }
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: { xs: '100%', md: 'none' },
                    border: { xs: 1, lg: 0 },
                    borderColor: { xs: 'grey.200', lg: 'none' },
                    borderRadius: { xs: '18px', md: 0 },
                    boxShadow: { xs: '0 2px 8px rgba(0, 0, 0, 0.06)', lg: 'none' },
                    p: { xs: 0, md: 0 },
                    mx: { xs: 2, md: 0 },
                    px: { md: 3, lg: 4 },
                    pb: { xs: 3, lg: 1 }
                }}
            >
                {children}
            </Box>
        </Box>
    )
}
